import { MARKETPLACE_TAB } from 'constants/marketplace';

export const isWatchlistFocussed = (focussedSourceTab) => focussedSourceTab === MARKETPLACE_TAB.watchlist;

// it mutates the original array
export const insertVehicleIntoIdslist = (entities, vehicleIds, newVehicle, itemsPerPage) => {
	let newElementIndex = 0;
	while (
		newElementIndex < vehicleIds.length &&
		entities[vehicleIds[newElementIndex]].bid_sale_id > newVehicle.bid_sale_id
	) {
		newElementIndex++;
	}
	vehicleIds.splice(newElementIndex, 0, newVehicle.id);
	// keep size if needed
	if (vehicleIds.length > itemsPerPage) vehicleIds.pop();
};

export const calculatePages = (totalElements, itemsPerPage) => Math.ceil(totalElements / itemsPerPage);

export const calculatePaginationAfterAddition = (totalElements, itemsPerPage) => {
	const updatedTotalElements = totalElements + 1;
	return {
		totalElements: updatedTotalElements,
		pageCount: calculatePages(updatedTotalElements, itemsPerPage),
	};
};

export const removeFromVehicleIds = ({
	vehicleIds,
	vehicleIdToRemove,
	totalElements = 1,
	itemsPerPage = 30,
	checkPresenceOnVehicleIdsToCalculatePagination = false,
}) => {
	const vehicleIdsFiltered = vehicleIds.filter((vehicleId) => vehicleIdToRemove !== vehicleId);
	let modifiedTotalElements = totalElements - 1;
	if (checkPresenceOnVehicleIdsToCalculatePagination) {
		modifiedTotalElements = vehicleIdsFiltered.length + 1 === vehicleIds.length ? totalElements - 1 : totalElements;
	}
	return {
		vehicleIds: vehicleIdsFiltered,
		totalElements: modifiedTotalElements,
		pageCount: calculatePages(modifiedTotalElements, itemsPerPage),
	};
};
